import { memo } from 'react'

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

type OwnProps = {
  onChange: (sort: string) => void
}

const optionLabel = {
  DATE: 'По дате',
  UNREAD: 'Сначала непрочитанные',
}

const NotificationSortInner = ({ onChange }: OwnProps) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="sort-label" size="small" sx={{ align: 'center' }}>
        Сортировка
      </InputLabel>
      <Select
        defaultValue="DATE"
        label="Сортировка"
        labelId="sort-label"
        size="small"
        onChange={event => onChange(event.target.value)}
      >
        <MenuItem value="DATE">{optionLabel.DATE}</MenuItem>
        <MenuItem value="UNREAD">{optionLabel.UNREAD}</MenuItem>
      </Select>
    </FormControl>
  )
}

export const NotificationSort = memo(NotificationSortInner)
